export default class SelectCustom {
  constructor () {
    $('[data-is-select=""]').select2()
  }
}
